import React from "react";
import { inject } from "mobx-react";
import HttpClient from "services/HttpClient";

@inject("modal")
export default class EmailTemplate extends React.Component {
  state = {
    email: {}
  };

  componentDidMount() {
    this.getEmailTemplate();
  }

  componentWillUnmount() {
    this.props.modal.setAssignedTo({});
  }

  getEmailTemplate = () => {
    const url = `/api/v1/attendees_list/email_template?workshop_id=${
      this.props.modal.parentId
    }`;
    new HttpClient().get(url).then(response => {
      this.setState({
        email: response.body
      });
    });
  };

  render() {
    return (
      <div className="modal-window-wrapper">
        <div className="inner-modal-window">
          <div
            className="close-btn"
            onClick={() => this.props.modal.toggleModal()}
          >
            <div className="close-btn-wrapper">
              <span />
              <span />
            </div>
          </div>
          <div className="email-template">
            <p>Subject of the email:</p>
            <h1>{this.state.email.subject || "Waiting..."}</h1>

            <p>Body:</p>
            <pre>
              {this.state.email.body || "Waiting for response from server."}
            </pre>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/EmailTemplate.jsx